import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { FileGroup, SelectFieldStatus, TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
// import { Button } from "@mui/material";
// import { BsCalendar2Plus } from "react-icons/bs";
import {
	Guarantor_1,
	Guarantor_2,
	LeaseInformation,
	LeaseeInformation,
	LeasorInformation,
} from "../partials/FormFields";
import { StyledForm } from "../../../components/Form/FormComponents.styled";

// eslint-disable-next-line no-unused-vars
const CompletedLeaseForm = ({ leaseData, setLeaseData, updateLeaseObject }) => {
	const [formData, setFormData] = useState(leaseData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(leaseData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(formData);
		setLeaseData(formData);
		updateLeaseObject(formData);
	};

	return (
		<StyledForm onSubmit={handleSubmit}>
			<ActionSideBar leaseData={formData} handleCancel={handleCancel} />

			<div className='RightSection'>
				<FormAccordion title='Lease Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<LeaseInformation
							formData={formData}
							isEditable={isEditable}
							handleInputChange={handleInputChange}
						/>
						{formData?.paymentStatus?.toLowerCase() === "default" && (
							<>
								{/* <div className='form-group'>
									<Button color='success' endIcon={<BsCalendar2Plus />} sx={{ width: "fit-content" }}>
										Assign new deadline
									</Button>
								</div> */}
							</>
						)}
					</div>
				</FormAccordion>

				<FormAccordion title='Product description'>
					<div className='form-group'>
						<TextAreaField
							name='product_desc'
							value={formData?.description || formData?.productId.description}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Key features'>
					<div className='form-group'>
						<TextAreaField
							name='product_features'
							value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Product specifications'>
					<div className='form-group'>
						<TextAreaField
							name='product_specs'
							value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
						/>
					</div>
				</FormAccordion>

				<FormAccordion title='Leasor’s Information'>
					<LeasorInformation formData={formData} />
				</FormAccordion>

				<FormAccordion title='Leasee’s Information'>
					<LeaseeInformation formData={formData} />
				</FormAccordion>

				<FormAccordion title='ID card'>
					<div className='form-group'>
						<FileGroup name='idCard' value={formData?.userId?.idCard} />
					</div>
				</FormAccordion>

				<FormAccordion title='Utility bill'>
					<div className='form-group'>
						<FileGroup name='utilityBill' value={formData?.userId?.utilityBill} />
					</div>
				</FormAccordion>

				<FormAccordion title='Auto debit'>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<SelectFieldStatus
								name='auto_debit'
								handleChange={handleInputChange}
								value={formData?.auto_debit}
								type={"success"}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Insurance'>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<SelectFieldStatus
								name='insurance'
								handleChange={handleInputChange}
								value={formData?.insurance}
								type={"success"}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Guarantor 1'>
					<Guarantor_1 formData={formData} />
				</FormAccordion>

				<FormAccordion title='Guarantor 2'>
					<Guarantor_2 formData={formData} />
				</FormAccordion>

				<FormAccordion title='Credit assessment'>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<SelectFieldStatus
								name='creditAssessment'
								handleChange={handleInputChange}
								value={formData?.creditAssessment}
								type={"success"}
							/>
						</div>
					</div>
				</FormAccordion>
			</div>
		</StyledForm>
	);
};

// Props Validation
CompletedLeaseForm.propTypes = {
	leaseData: PropTypes.object,
	setLeaseData: PropTypes.func,
	updateLeaseObject: PropTypes.func,
};

export default CompletedLeaseForm;
